<template>
    <div class="">
        <install-wizard-card :special-route="wizardHelper.nextStepRoute" :should-complete="false">
            <template #top-header>
                SoniCloud Implementation Wizard
            </template>
            <template #top-content>
                Let's get your SoniCloud system up and running!
            </template>

            <template #body-summary>
                <div v-if="wizardHelper.completePercent > 0">
                    Great news, you're currently {{wizardHelper.completePercent}}% done! Let's wrap this up!
                </div>
            </template>

            <template #body-action>
                <div class="bg-white shadow overflow-hidden sm:rounded-md">
                    <ul>
                        <li v-for="(wizard, index) in wizardHelper.wizardSteps" :class="index !== 0 ? 'border-t border-gray-200' : ''">
                            <a :href="company.buildCompanyRoute('wizard/' + wizard.route)" class="block plain-link hover:bg-gray-50 focus:outline-none focus:bg-gray-50">
                                <div class="px-4 py-4 sm:px-6">
                                    <div class="flex items-center justify-between">
                                        <div class="text-sm leading-5 font-medium truncate text-gray-800">
                                            <span :class="wizard.icon" class="lnr"></span>
                                            {{wizard.text}}
                                        </div>
                                        <div class="ml-2 shrink-0 flex">
                                          <span :class="isWizardModelComplete(wizard.model) ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'"
                                                  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full">
                                              <span v-if="isWizardModelComplete(wizard.model)">Done!</span>
                                              <span v-else>To Be Completed</span>
                                          </span>
                                        </div>
                                    </div>
                                    <div class="mt-2 sm:flex sm:justify-between">
                                        <div class="sm:flex">
                                            <div v-if="wizard.model && wizard.model.user">
                                                <div class="mr-6 flex items-center text-sm leading-5 text-gray-500">
                                                    <svg class="shrink-0 mr-1.5 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                                                        <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"/>
                                                    </svg>
                                                    {{wizard.model.user.display_name}} ({{wizard.model.user.email}})
                                                </div>
                                            </div>
                                            <div class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mt-0">
<!--Placeholder-->
                                            </div>
                                        </div>
                                        <div v-if="isWizardModelComplete(wizard.model)" class="mt-2 flex flex-nowrap items-center text-sm leading-5 text-gray-500 sm:mt-0">
<!--                                            <span v-if="isWizardModelComplete(wizard.model)" class="">-->
                                                <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"/>
                                                </svg>
                                                <span>{{wizard.model.completed_at_readable}}</span>
<!--                                            </span>-->
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </template>

            <template #bottom-header>
                Ready to get going?
            </template>
            <template #bottom-content>
                Let's go ahead and knock out the next little bit.
            </template>
            <template #bottom-button-text>
                Next Step!
            </template>
        </install-wizard-card>
    </div>
</template>

<script>
    import InstallWizardCard from "./InstallWizardCard";
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

    export default {
        name: "InstallWizardIndex",
        props: {
            wizardHelper: Object,
        },
        mixins: [SonicuCoreMixin],
        components: {InstallWizardCard},
        methods: {
            isWizardModelComplete(model){
                if(model === undefined || model === null){
                    return false;
                }
                return model.is_complete;
            }
        }
    }
</script>

<style scoped>

</style>